import { em } from 'polished'
import PropTypes from 'prop-types'
import React from 'react'

import { REGION_JP } from 'constants/regions'

import { chartFadeIn } from './animations'

const isJp = REGION_JP === process.env.region

const BHowRetestChart = ({ data, isMobile, isDesktop, ...props }) => {
  const [circlesRef] = React.useState(() =>
    [...Array(3)].map(() => React.createRef()),
  )
  const [numbersRef] = React.useState(() =>
    [...Array(3)].map(() => React.createRef()),
  )
  const [dateRef] = React.useState(() =>
    [...Array(3)].map(() => React.createRef()),
  )
  const [lineRef] = React.useState(() =>
    [...Array(2)].map(() => React.createRef()),
  )
  const [dottedLinesRef] = React.useState(() =>
    [...Array(3)].map(() => React.createRef()),
  )

  const verticalLine1 = '6'
  const verticalLine2 = React.useMemo(() => (isMobile ? '90' : '110'), [
    isMobile,
  ])
  const verticalLine3 = React.useMemo(() => (isMobile ? '175' : '215'), [
    isMobile,
  ])

  const [circleY1, circleY2] = ['84', '35']

  React.useEffect(() => {
    chartFadeIn({
      circlesRef,
      numbersRef,
      dateRef,
      lineRef,
      dottedLinesRef,
      verticalLine1,
      verticalLine2,
      verticalLine3,
      circleY1,
      circleY2,
      isDesktop,
    })
  }, [
    circleY1,
    circleY2,
    isDesktop,
    verticalLine2,
    verticalLine3,
    circlesRef,
    numbersRef,
    dateRef,
    lineRef,
    dottedLinesRef,
  ])

  const dateReport = React.useMemo(() => data.report.split('<br/>'), [
    data.report,
  ])

  return (
    <svg
      width={isDesktop ? '165%' : isMobile ? em(285) : em(300)}
      height={isDesktop ? '100%' : em(245)}
      viewBox={isDesktop ? '0 0 285 285' : null}
      fill="none"
      {...props}
    >
      <line
        opacity={0}
        ref={dottedLinesRef[0]}
        x1={verticalLine1}
        y1="82"
        x2={verticalLine1}
        y2="185"
        strokeDasharray="4 4"
        stroke="#000"
      />
      <line
        opacity={0}
        ref={dottedLinesRef[1]}
        x1={verticalLine2}
        y1="42"
        x2={verticalLine2}
        y2="185"
        strokeDasharray="4 4"
        stroke="#000"
      />
      <line
        opacity={0}
        ref={dottedLinesRef[2]}
        x1={verticalLine3}
        y1="62"
        x2={verticalLine3}
        y2="185"
        strokeDasharray="4 4"
        stroke="#000"
      />

      <line
        ref={lineRef[0]}
        x1={verticalLine1}
        y1="84"
        x2={verticalLine1}
        y2="84"
        stroke="#000"
      />
      <line
        ref={lineRef[1]}
        x1={verticalLine2}
        y1="35"
        x2={verticalLine2}
        y2="35"
        stroke="#000"
      />
      <text
        ref={numbersRef[0]}
        fontSize={24}
        x={verticalLine1 - 6}
        y="70"
        fill="#FDB432"
      >
        5
      </text>
      <text
        ref={numbersRef[1]}
        opacity={0}
        fontSize={24}
        x={verticalLine2 - 6}
        y="25"
        fill="#00DA67"
      >
        8
      </text>
      <text
        ref={numbersRef[2]}
        opacity={0}
        fontSize={24}
        x={verticalLine3 - 6}
        y="45"
        fill="#00DA67"
      >
        7
      </text>

      <text
        opacity={0}
        ref={dateRef[0]}
        fontSize={isMobile ? 10 : 14}
        x="10"
        y="195"
        fill="rgba(0, 0, 0, 0.3)"
      >
        <tspan
          x={verticalLine1 - 7}
          dy="16"
          dangerouslySetInnerHTML={{ __html: dateReport[0] }}
        />
        {dateReport[1] && (
          <tspan
            x={verticalLine1 - 7}
            dy="16"
            dangerouslySetInnerHTML={{ __html: dateReport[1] }}
          />
        )}
        <tspan x={verticalLine1 - 7} dy="16">
          {isJp ? '2020.03.06' : '06.03.2020'}
        </tspan>
      </text>
      <text
        opacity={0}
        ref={dateRef[1]}
        fontSize={isMobile ? 10 : 14}
        x="0"
        y="195"
        fill="rgba(0, 0, 0, 0.3)"
      >
        <tspan
          x={verticalLine2 - 7}
          dy="16"
          dangerouslySetInnerHTML={{ __html: dateReport[0] }}
        />
        {dateReport[1] && (
          <tspan
            x={verticalLine2 - 7}
            dy="16"
            dangerouslySetInnerHTML={{ __html: dateReport[1] }}
          />
        )}
        <tspan x={verticalLine2 - 7} dy="16">
          {isJp ? '2020.07.01' : '01.07.2020'}
        </tspan>
      </text>

      <text
        opacity={0}
        ref={dateRef[2]}
        fontSize={isMobile ? 10 : 14}
        x="0"
        y="195"
        fill="black"
      >
        <tspan
          x={verticalLine3 - 7}
          dy="16"
          dangerouslySetInnerHTML={{ __html: dateReport[0] }}
        />
        {dateReport[1] && (
          <tspan
            x={verticalLine3 - 7}
            dy="16"
            dangerouslySetInnerHTML={{ __html: dateReport[1] }}
          />
        )}
        <tspan x={verticalLine3 - 7} dy="16">
          {isJp ? '2020.10.12' : '12.10.2020'}
        </tspan>
      </text>
      <circle
        ref={circlesRef[0]}
        stroke="#FBB343"
        strokeWidth={2}
        fill="white"
        cx={verticalLine1}
        cy="84"
        r="0"
      />
      <circle
        ref={circlesRef[1]}
        stroke="#00DA67"
        strokeWidth={2}
        fill="white"
        cx={verticalLine2}
        cy="35"
        r="0"
      />

      <circle
        ref={circlesRef[2]}
        stroke="#00DA67"
        strokeWidth={2}
        fill="#00DA67"
        cx={verticalLine3}
        cy="56"
        r="0"
      />
    </svg>
  )
}

BHowRetestChart.propTypes = {
  data: PropTypes.object,
  isMobile: PropTypes.bool,
  isDesktop: PropTypes.bool,
}

export default BHowRetestChart
